import { wrapperStyleType, IBookingMenuOption, ISimpleBookingOption } from 'shared-types/index';
import { GridSpacing } from '@material-ui/core/Grid';
import {MenuOptionsState} from "external-components/booking-options-section/ChildMenuOptionOverlay/types";
import {IWidgetTheme} from 'shared-types/MUI4ThemeTypes';

export interface IBookingUpsellOptionsPanel {
  isUpsell: boolean;
  forceDisableBookingUpsellOptions?: boolean;
  scrollRef?: HTMLElement;
}

export interface IBookingUpsellOptionsProps {
  disableBookingUpsellOptions?: boolean;
}

export interface IUpsellProps {
  theme: IWidgetTheme;
  wrapperStyle: wrapperStyleType;
  selectedMenuOptions: IBookingMenuOption[];
  menuOptions: ISimpleBookingOption[];
  currency: string; // AUD, GBP, USD, etc
  gridSizes: (boolean | 2 | 1 | 'auto' | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12)[];
  gridGutter: GridSpacing;
  isUpsell?: boolean;
  isDesignV2?: boolean;
  disableBookingUpsellOptions?: boolean;
  stateType: MenuOptionsState;
}

export interface IHandlers {
  handleUpsellUpdate: (selectedMenuOptions: IBookingMenuOption[]) => void;
}

export const DocumentTypes = {
  MenuOption: 'menuoption',
};
